import React, { useEffect } from 'react';
import { useSetState } from 'ahooks';
import { TabBar } from 'antd-mobile-v2';
import { useHistory, useLocation } from 'react-router';
// import { useSelector } from '@/utils/redux';

import bookcenter from '@/api/bookcenter';
// import GoToWeappModal from '../GoToWeappModal/GoToWeappModal';
import { useUrlInfo } from '@/utils/hooks';
import * as storageConstants from '@/constants/storage';

import './FooterTabBar.scss';
function FooterTabBar() {

  const { query, search } = useUrlInfo();

  const defaultTabBarData = [
    {
      title: '首页',
      code: 'home',
      path: '/rayh5/home'
    },
    {
      title: '本书服务',
      code: 'book',
      path: '/rayh5/book'
    },
    {
      title: '我的',
      code: 'mine',
      path: '/rayh5/mine'
    }
  ];

  const oldTabBarData = [
    {
      title: '本书服务',
      code: 'book',
      path: '/rayh5/book/old'
    },
    {
      title: '我的',
      code: 'mine',
      path: '/rayh5/mine'
    }
  ];
  const [state, setState] = useSetState({
    // showModal: false,
    TabBarData: defaultTabBarData,
    hadJumpSceneId: []
  });
  const { pathname } = useLocation();

  const history = useHistory();
  // const { jumpWay } = useSelector(state => state.reader);

  //获取特殊逻辑url，决定是否菜单跳转过去
  const getSpecialUrl = () => {
    let isFromDL = query.referrerPage === 'DL';
    let localDLUrl = window.sessionStorage.getItem(storageConstants.SESSION_STORAGE_REFERER_PAGE);
    let url = '';
    if(isFromDL && localDLUrl) {
      url = localDLUrl;
    }
    return url;
  };

  useEffect(() => {
    // const { query = {}} = Locator;
    // const { sceneId } = query;
    // hadJumpSceneId不存在或者不包含sceneId时跳转小程序
    const reqParams = query.bookGroupId ? { bookGroupId: query?.bookGroupId } : { sceneId: query?.sceneId };
    if(query.bookGroupId || query?.sceneId) {
      bookcenter.getResourcePageByBookGroupId4Wechat(reqParams).then(data => {
        if(pathname === '/rayh5/book/old' && data.showSelf) {
          setState({
            TabBarData: oldTabBarData
          });
        } else {
          setState({
            TabBarData: defaultTabBarData
          });
        }
      });
    }
  }, [state.hadJumpSceneId]);

  useEffect(() => {
    try {
      const hadJumpSceneId = localStorage.getItem('HAD_JUNP_SCENE') ? JSON.parse(localStorage.getItem('HAD_JUNP_SCENE')) : [];
      // 未存储HAD_JUNP_SCENE或者已存储但不包含当前sceneId
      setState({
        hadJumpSceneId
      });
    } catch(e) {
      console.error('HAD_JUNP_SCENE', localStorage.getItem('HAD_JUNP_SCENE'), e);
    }
  }, []);

  return <div className={`FooterTabBar ${window.location.pathname.indexOf('/rayh5/member') === -1 ? 'showSafe' : ''}`} style={{ position: 'fixed', width: '100%', bottom: 0, zIndex: 100 }}>
    {/* <GoToWeappModal
      showModal={state.showModal}
      closeable
      onClose={() => {
        setState({ showModal: false });
        history.push('/rayh5/home');
      }}
    /> */}
    <TabBar
      unselectedTintColor="#2F2F2F"
      tintColor="#33A3F4"
      barTintColor="white"
      hidden={!state.TabBarData.some(v => v.path === pathname)}
    >
      {
        state.TabBarData.map((item, index) => {
          return <TabBar.Item
            title={item.title}
            key={index}
            selected={pathname === item.path}
            icon={<div className={`tab-item-icon tab-item-icon-${item.code}`} />}
            selectedIcon={<div className={`tab-item-icon tab-item-icon-actived-${item.code}`} />}
            onPress={() => {
              let pageUrl = item.path + search;
              if(['/rayh5/book', '/rayh5/book/old'].includes(item.path)) {
                if(getSpecialUrl()) {
                  //如果是特殊逻辑，例如斗罗要回到自己的home页
                  pageUrl = getSpecialUrl();
                }
              }
              history.push(pageUrl);
            }}
          />;

        })
      }
    </TabBar>
  </div>;

}

export default FooterTabBar;

